<template>
  <div class="lishihuiche-page">
    <!-- 科技感加载动画 -->
    <AiLoading :visible="loading" title="正在运行历史回测中"></AiLoading>

    <div style="display: none;" @click="runAudio">隐藏播放音频按钮</div>
    <div class="header">
      <div class="logo">
        <div class="icon">
          <img src="@/assets/lishihuice/icon2.png">
        </div>
        <h1>历史回测参数设置</h1>
      </div>
      <div class="subtitle">
        <!-- 基于 2016-2026 年历史数据模拟 -->
        基于历史数据模拟
      </div>
    </div>

    <div class="content">
      <div class="left-panel">
        <h2 class="panel-title">
          <i class="el-icon-s-data"></i>
          回测参数配置
        </h2>

        <div class="parameter-list">
          <div class="parameter-item">
            <div>
              <div class="parameter-header">
                <img src="@/assets/lishihuice/setting1.png">
                <span>1. 回测时间范围</span>
                <!-- <el-popover placement="right" width="400" trigger="click">
                  <el-table :data="tishi.tabledata">
                    <el-table-column property="name" label="股票名称"></el-table-column>
                    <el-table-column property="dataAvailableFrom" label="开始日期"></el-table-column>
                    <el-table-column property="dataAvailableTo" label="结束日期"></el-table-column>
                  </el-table>
                  <i class="el-icon-question" :title="'点击查看解析'" slot="reference"></i>
                </el-popover> -->

              </div>
              <div class="parameter-description">
                <div>选择历史回测的时间周期</div>
                <div><span style="color:red;">建议使用推荐时间范围：{{ tishi.start }}至{{ tishi.end }}</span></div>
              </div>
            </div>
            <div>
              <div class="parameter-control">
                <div class="datepicker-trigger" @click="openDatePicker">
                  <svg class="datepicker-trigger-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 9H21M7 3V5M17 3V5M6 12H8M11 12H13M16 12H18M6 15H8M11 15H13M16 15H18M6 18H8M11 18H13M16 18H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span class="datepicker-trigger-text"
                        :class="{ placeholder: !parameters.timeRange[0] || !parameters.timeRange[1] }">{{ timeRangeText
                        }}</span>
                </div>
              </div>
              <div v-if="showDatePicker" class="numpad-mask" @click="closeDatePicker"></div>
              <div v-if="showDatePicker" class="datepicker-popup" @click.stop>
                <div class="datepicker-header">
                  <div class="datepicker-header-title">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 9H21M7 3V5M17 3V5M6 12H8M11 12H13M16 12H18M6 15H8M11 15H13M16 15H18M6 18H8M11 18H13M16 18H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                            stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    选择回测时间范围
                  </div>
                  <button class="numpad-popup-close" @click="closeDatePicker">✕</button>
                </div>
                <div class="datepicker-body">
                  <div class="datepicker-col">
                    <div class="datepicker-col-header">
                      <span class="col-dot start"></span>
                      <span class="datepicker-col-label">开始日期</span>
                    </div>
                    <div class="datepicker-col-sub">回测起始时间</div>
                    <div class="datepicker-selects">
                      <select v-model="dateStartYear" class="datepicker-select">
                        <option v-for="y in dateYears" :key="y" :value="y">{{ y }}年</option>
                      </select>
                      <select v-model="dateStartMonth" class="datepicker-select">
                        <option v-for="m in 12" :key="m" :value="m">{{ m }}月</option>
                      </select>
                      <div class="datepicker-custom-select" :class="{ open: activeDaySelect === 'start' }">
                        <div class="datepicker-custom-trigger" @click="toggleDaySelect('start')">{{ dateStartDay }}日
                        </div>
                        <div v-if="activeDaySelect === 'start'" class="datepicker-custom-options">
                          <div v-for="d in dateStartDays" :key="d" class="datepicker-custom-option"
                               :class="{ selected: d === dateStartDay }" @click="selectDay('start', d)">{{ d }}日</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="datepicker-divider">
                    <div class="datepicker-divider-line"></div>
                    <div class="datepicker-divider-icon">→</div>
                    <div class="datepicker-divider-line"></div>
                  </div>
                  <div class="datepicker-col">
                    <div class="datepicker-col-header">
                      <span class="col-dot end"></span>
                      <span class="datepicker-col-label">结束日期</span>
                    </div>
                    <div class="datepicker-col-sub">回测结束时间</div>
                    <div class="datepicker-selects">
                      <select v-model="dateEndYear" class="datepicker-select">
                        <option v-for="y in dateYears" :key="y" :value="y">{{ y }}年</option>
                      </select>
                      <select v-model="dateEndMonth" class="datepicker-select">
                        <option v-for="m in 12" :key="m" :value="m">{{ m }}月</option>
                      </select>
                      <div class="datepicker-custom-select" :class="{ open: activeDaySelect === 'end' }">
                        <div class="datepicker-custom-trigger" @click="toggleDaySelect('end')">{{ dateEndDay }}日</div>
                        <div v-if="activeDaySelect === 'end'" class="datepicker-custom-options">
                          <div v-for="d in dateEndDays" :key="d" class="datepicker-custom-option"
                               :class="{ selected: d === dateEndDay }" @click="selectDay('end', d)">{{ d }}日</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="datepicker-footer">
                  <button class="datepicker-btn datepicker-btn-secondary" @click="closeDatePicker">取消</button>
                  <button class="datepicker-btn datepicker-btn-primary" @click="confirmDatePicker">确认选择</button>
                </div>
              </div>
            </div>
          </div>

          <div class="parameter-item">
            <div>
              <div class="parameter-header">
                <img src="@/assets/lishihuice/setting2.png">
                <span>2. 初始资金（虚拟本金）</span>
              </div>
              <div class="parameter-description">
                模拟投资的初始资金
              </div>
            </div>
            <div>
              <div class="parameter-control">
                <!-- <span>￥</span> -->
                <div class="numpad-trigger" @click="openNumpad">
                  <span class="numpad-display">{{ displayFund }}</span>
                </div>
              </div>
              <div v-if="showNumpad" class="numpad-mask" @click="closeNumpad"></div>
              <div v-if="showNumpad" class="numpad-popup" @click.stop>
                <div class="numpad-popup-header">
                  <span>请输入初始资金</span>
                  <button class="numpad-popup-close" @click="closeNumpad">✕</button>
                </div>
                <div class="numpad-popup-display">￥{{ numpadValue || '0' }}</div>
                <div class="numpad-grid">
                  <button class="numpad-btn" v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="n"
                          @click="numpadInput(String(n))">{{ n }}</button>
                  <button class="numpad-btn numpad-btn-zero" @click="numpadInput('0')">0</button>
                  <button class="numpad-btn" @click="numpadInput('.')">.</button>
                  <button class="numpad-btn numpad-btn-del" @click="numpadDelete">删除</button>
                </div>
                <button class="numpad-confirm" @click="confirmNumpad">确认</button>
              </div>
            </div>
          </div>

          <div class="parameter-item">
            <div>
              <div class="parameter-header">
                <img src="@/assets/lishihuice/setting3.png">
                <span>3. 调仓频率</span>
              </div>
              <div class="parameter-description">
                资产再平衡的时间间隔
              </div>
            </div>
            <div>
              <div class="parameter-control">
                <el-select v-model="parameters.rebalanceFreq" id="select-rebalance-freq" class="select-control"
                           size="mini">
                  <el-option label="不调仓" value="0"></el-option>
                  <el-option label="周调仓" value="1"></el-option>
                  <el-option label="月调仓" value="2"></el-option>
                  <el-option label="季度调仓" value="3"></el-option>
                  <el-option label="年调仓" value="4"></el-option>
                </el-select>
              </div>
            </div>

          </div>

          <div class="parameter-item">
            <div>
              <div class="parameter-header">
                <img src="@/assets/lishihuice/setting4.png">
                <span>4. 交易成本费率</span>
              </div>
              <div class="parameter-description">
                每笔交易的成本和印花税
              </div>
            </div>
            <div>
              <div class="parameter-control">
                <div class="numpad-trigger" @click="openNumpadCost">
                  <span class="numpad-display">{{ parameters.transactionCost }}</span>
                </div>
              </div>
              <div v-if="showNumpadCost" class="numpad-mask" @click="closeNumpadCost"></div>
              <div v-if="showNumpadCost" class="numpad-popup" @click.stop>
                <div class="numpad-popup-header">
                  <span>请输入交易成本费率</span>
                  <button class="numpad-popup-close" @click="closeNumpadCost">✕</button>
                </div>
                <div class="numpad-popup-display">{{ numpadCostValue || '0' }}</div>
                <div class="numpad-grid">
                  <button class="numpad-btn" v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="n"
                          @click="numpadCostInput(String(n))">{{ n }}</button>
                  <button class="numpad-btn numpad-btn-zero" @click="numpadCostInput('0')">0</button>
                  <button class="numpad-btn" @click="numpadCostInput('.')">.</button>
                  <button class="numpad-btn numpad-btn-del" @click="numpadCostDelete">删除</button>
                </div>
                <button class="numpad-confirm" @click="confirmNumpadCost">确认</button>
              </div>
            </div>
          </div>

          <div class="parameter-item">
            <div>
              <div class="parameter-header">
                <img src="@/assets/lishihuice/setting5.png">
                <span>5. 基准选择（对比对象）</span>
              </div>
              <div class="parameter-description">
                用于比较投资收益的基准
              </div>
            </div>
            <div>
              <div class="parameter-control">
                <el-select v-model="parameters.benchmark" id="select-benchmark" class="select-control" size="mini">
                  <el-option label="沪深300 ETF" value="510300"></el-option>
                  <el-option label="中证500 ETF" value="510500"></el-option>
                  <el-option label="创业板指 ETF" value="159915"></el-option>
                  <el-option label="债市综合指数 ETF" value="511010"></el-option>
                  <el-option label="不对比" value="null"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-panel">
        <div class="preview-section">
          <h2 class="panel-title">
            <i class="el-icon-view"></i>
            参数预览
          </h2>
          <div class="preview-item">
            <span class="preview-label">时间范围</span>
            <span class="preview-value">{{ timeRangeText }}</span>
          </div>
          <div class="preview-item">
            <span class="preview-label">初始资金</span>
            <span class="preview-value">￥{{ parameters.initialFund.toLocaleString() }}</span>
          </div>
          <div class="preview-item">
            <span class="preview-label">调仓频率</span>
            <span class="preview-value">{{ rebalanceFreqText }}</span>
          </div>
          <div class="preview-item">
            <span class="preview-label">交易成本</span>
            <span class="preview-value">{{ parameters.transactionCost }} ({{ (parseFloat(parameters.transactionCost) *
              100).toFixed(3) }}%)</span>
          </div>
          <div class="preview-item">
            <span class="preview-label">基准指数</span>
            <span class="preview-value">{{ benchmarkText }}</span>
          </div>
        </div>

        <div class="warning-section">
          <h2 class="panel-title">
            <i class="el-icon-warning-outline"></i>
            温馨提示
          </h2>
          <ul class="warning-list">
            <li>回测基于历史数据模拟，不代表未来实际收益</li>
            <li>交易成本已包含佣金和印花税，接近真实交易</li>
            <li>基准指数用于评估策略的相对表现</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="reset-btn common-btn" id="btn-reset-weight-backtest" @click="handleReset">
        重新调整权重 <i class="el-icon-refresh"></i>
      </button>
      <button class="start-btn common-btn" id="btn-start-backtest" @click="handleStart">
        开始运行历史回测 <i class="el-icon-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import apiOpen from '@/api/open'
import AiLoading from '@/components/AiLoading.vue'
export default {
  name: 'Lishihuiche',
  components: {
    AiLoading
  },
  data () {
    return {
      loading: false,
      parameters: {
        timeRange: ['', ''],
        initialFund: '100000',
        rebalanceFreq: '3',
        transactionCost: '0.001',
        benchmark: '510300'
      },
      tishi: {
        tabledata: [],
        start: '',
        end: ''
      },
      paramsSyncTimer: null,
      showNumpad: false,
      numpadValue: '',
      showNumpadCost: false,
      numpadCostValue: '0.001',
      showDatePicker: false,
      dateStartYear: 2016,
      dateStartMonth: 1,
      dateStartDay: 1,
      dateEndYear: 2026,
      dateEndMonth: 5,
      dateEndDay: 31,
      activeDaySelect: null
    }
  },
  computed: {
    timeRangeText () {
      if (Array.isArray(this.parameters.timeRange) && this.parameters.timeRange.length === 2 && this.parameters.timeRange[0] && this.parameters.timeRange[1]) {
        return `${this.parameters.timeRange[0]} 至 ${this.parameters.timeRange[1]}`
      }
      return '请选择日期范围'
    },
    dateYears () {
      const years = []
      for (let y = 2010; y <= 2026; y++) years.push(y)
      return years
    },
    dateStartDays () {
      const d = new Date(this.dateStartYear, this.dateStartMonth, 0)
      return d.getDate()
    },
    dateEndDays () {
      const d = new Date(this.dateEndYear, this.dateEndMonth, 0)
      return d.getDate()
    },
    rebalanceFreqText () {
      const map = {
        '0': '不调仓',
        '1': '周调仓',
        '2': '月调仓',
        '3': '季度调仓',
        '4': '年调仓'
      }
      return map[this.parameters.rebalanceFreq] || '季度调仓'
    },
    benchmarkText () {
      const map = {
        '510300': '沪深300 ETF',
        '510500': '中证500 ETF',
        '159915': '创业板指 ETF',
        '511010': '债市综合指数 ETF',
        'null': '不对比'
      }
      return map[this.parameters.benchmark] || '沪深300 ETF'
    },
    displayFund () {
      const v = this.parameters.initialFund
      return Number(v).toLocaleString()
    }
  },
  created () {
    this.runAudio()
    // 根据 followUpOptions 匹配默认基准指数（有回测记录但无 benchmark 时也生效）
    let defaultBenchmark = '510300'
    const followUpText = localStorage.getItem('followUpOptions')
    if (followUpText) {
      const benchmarkMap = {
        '沪深300': '510300',
        '中证500': '510500',
        '创业板指': '159915',
        '债市综合指数': '511010'
      }
      if (benchmarkMap[followUpText]) {
        defaultBenchmark = benchmarkMap[followUpText]
      }
    }
    let backtestParams = JSON.parse(localStorage.getItem('backtestParams'))
    if (backtestParams) {//如果有回测记录
      this.parameters.timeRange = [backtestParams.startDate, backtestParams.endDate]
      this.parameters.initialFund = backtestParams.initialCapital
      this.parameters.rebalanceFreq = backtestParams.rebalanceFrequency + ''
      this.parameters.transactionCost = (backtestParams.transactionCostRate && backtestParams.transactionCostRate !== '0') ? backtestParams.transactionCostRate : '0.001'
      this.parameters.benchmark = backtestParams.benchmarkCode || defaultBenchmark
    }
    else {//如果没有回测记录
      const parameters = {
        timeRange: ['', ''],
        initialFund: '100000',
        rebalanceFreq: '3',
        transactionCost: '0.001',
        benchmark: defaultBenchmark
      }
      this.parameters = parameters
    }

  },
  mounted () {
    let newrecommendResult = JSON.parse(localStorage.getItem('NewrecommendResult'))
    this.tishi.tabledata = newrecommendResult.products.map(item => ({
      dataAvailableFrom: item.dataAvailableFrom,
      dataAvailableTo: item.dataAvailableTo,
      name: item.name
    }))
    // 优先使用资产配置页计算的数据区间交集
    const assetIntersection = JSON.parse(localStorage.getItem('assetDateIntersection'))
    if (assetIntersection && assetIntersection.start && assetIntersection.end) {
      this.tishi.start = assetIntersection.start
      this.tishi.end = assetIntersection.end
    } else {
      let recommendResult = JSON.parse(localStorage.getItem('recommendResult'))
      this.tishi.start = recommendResult.recommendedBacktestWindow.start
      this.tishi.end = recommendResult.recommendedBacktestWindow.end
    }

    // 若有资产交集缓存，直接使用交集时间，跳过旧记录恢复
    if (assetIntersection && assetIntersection.start && assetIntersection.end) {
      this.parameters.timeRange = [assetIntersection.start, assetIntersection.end]
    } else {
      // 若无历史回测记录，默认时间范围使用推荐的起止日期
      if (!this.parameters.timeRange[0] && !this.parameters.timeRange[1]) {
        this.parameters.timeRange = [this.tishi.start, this.tishi.end]
      }
      // 从 localStorage 恢复（供副屏使用）
      this.restoreParametersFromStorage()
    }
    window.addEventListener('storage', this.handleStorageChange)
    // 强制重置 loading，防止上一轮异常残留导致卡死
    this.loading = false
    localStorage.removeItem('lishihuice_loading')
  },
  beforeDestroy () {
    this.loading = false
    localStorage.removeItem('lishihuice_loading')
    window.removeEventListener('storage', this.handleStorageChange)
    if (this.paramsSyncTimer) {
      clearTimeout(this.paramsSyncTimer)
      this.paramsSyncTimer = null
    }
  },
  watch: {
    parameters: {
      handler () {
        this.syncParametersToStorage()
      },
      deep: true
    },
    // 选择月份后清空之前选的日（不同月份天数不同，避免出现无效日期如2月30日）
    dateStartMonth () {
      this.dateStartDay = 1
    },
    dateEndMonth () {
      this.dateEndDay = 1
    },
    loading (val) {
      localStorage.setItem('lishihuice_loading', JSON.stringify({ visible: val }))
    }
  },
  methods: {
    // 播放音频
    runAudio () {
      this.playOnceAudio('/回测参数设置后请点击下方按钮开始历史回测.mp3')
    },
    syncParametersToStorage () {
      if (this.paramsSyncTimer) clearTimeout(this.paramsSyncTimer)
      this.paramsSyncTimer = setTimeout(() => {
        localStorage.setItem('backtestParams', JSON.stringify({
          startDate: this.parameters.timeRange[0],
          endDate: this.parameters.timeRange[1],
          initialCapital: this.parameters.initialFund,
          rebalanceFrequency: this.parameters.rebalanceFreq,
          transactionCostRate: this.parameters.transactionCost,
          benchmarkCode: this.parameters.benchmark
        }))
        this.paramsSyncTimer = null
      }, 200)
    },
    handleStorageChange (event) {
      if (event.key === 'backtestParams' && event.newValue) {
        this.restoreParametersFromStorage()
      } else if (event.key === 'lishihuice_loading' && event.newValue) {
        try {
          this.loading = JSON.parse(event.newValue).visible
        } catch (e) { /* ignore */ }
      }
    },
    restoreParametersFromStorage () {
      const data = localStorage.getItem('backtestParams')
      if (!data) return
      try {
        const p = JSON.parse(data)
        if (p.startDate && p.endDate) {
          this.parameters = {
            timeRange: [p.startDate, p.endDate],
            initialFund: p.initialCapital || '100000',
            rebalanceFreq: String(p.rebalanceFrequency ?? '3'),
            transactionCost: (p.transactionCostRate && p.transactionCostRate !== '0') ? String(p.transactionCostRate) : '0.001',
            benchmark: p.benchmarkCode || '510300'
          }
        }
      } catch (e) {
        // ignore
      }
    },
    openNumpad () {
      this.numpadValue = String(this.parameters.initialFund)
      this.showNumpad = true
    },
    closeNumpad () {
      this.showNumpad = false
    },
    numpadInput (char) {
      if (char === '.' && this.numpadValue.includes('.')) return
      if (this.numpadValue.length >= 15) return
      this.numpadValue += char
    },
    numpadDelete () {
      this.numpadValue = this.numpadValue.slice(0, -1)
    },
    confirmNumpad () {
      this.parameters.initialFund = this.numpadValue || '0'
      this.showNumpad = false
      this.$forceUpdate()
    },
    openNumpadCost () {
      this.numpadCostValue = String(this.parameters.transactionCost)
      this.showNumpadCost = true
    },
    closeNumpadCost () {
      this.showNumpadCost = false
    },
    numpadCostInput (char) {
      if (char === '.' && this.numpadCostValue.includes('.')) return
      if (this.numpadCostValue.length >= 15) return
      this.numpadCostValue += char
    },
    numpadCostDelete () {
      this.numpadCostValue = this.numpadCostValue.slice(0, -1)
    },
    confirmNumpadCost () {
      this.parameters.transactionCost = this.numpadCostValue || '0.001'
      this.showNumpadCost = false
      this.$forceUpdate()
    },
    openDatePicker () {
      const range = this.parameters.timeRange
      if (Array.isArray(range) && range.length === 2) {
        const s = range[0].split('-')
        const e = range[1].split('-')
        this.dateStartYear = parseInt(s[0]) || 2016
        this.dateStartMonth = parseInt(s[1]) || 1
        this.dateStartDay = parseInt(s[2]) || 1
        this.dateEndYear = parseInt(e[0]) || 2026
        this.dateEndMonth = parseInt(e[1]) || 5
        this.dateEndDay = parseInt(e[2]) || 31
      } else {
        this.dateStartYear = 2016
        this.dateStartMonth = 1
        this.dateStartDay = 1
        this.dateEndYear = 2026
        this.dateEndMonth = 5
        this.dateEndDay = 31
      }
      this.showDatePicker = true
      document.addEventListener('click', this.handleDaySelectOutside)
    },
    closeDatePicker () {
      this.showDatePicker = false
      document.removeEventListener('click', this.handleDaySelectOutside)
      this.activeDaySelect = null
    },
    confirmDatePicker () {
      const pad = n => String(n).padStart(2, '0')
      const start = `${this.dateStartYear}-${pad(this.dateStartMonth)}-${pad(this.dateStartDay)}`
      const end = `${this.dateEndYear}-${pad(this.dateEndMonth)}-${pad(this.dateEndDay)}`
      this.parameters.timeRange = [start, end]
      this.showDatePicker = false
      document.removeEventListener('click', this.handleDaySelectOutside)
      this.activeDaySelect = null
      this.$forceUpdate()
    },
    toggleDaySelect (which) {
      this.activeDaySelect = this.activeDaySelect === which ? null : which
    },
    selectDay (which, day) {
      if (which === 'start') {
        this.dateStartDay = day
      } else {
        this.dateEndDay = day
      }
      this.activeDaySelect = null
    },
    handleDaySelectOutside (e) {
      if (this.activeDaySelect && !e.target.closest('.datepicker-custom-select')) {
        this.activeDaySelect = null
      }
    },
    handleStart () {
      // 这里可以添加开始回测的逻辑
      if (!this.parameters.timeRange[0] || !this.parameters.timeRange[1]) {
        this.$message.error('请选择时间范围')
        return
      }
      if (this.parameters.initialFund === '0') {
        this.$message.error('请输入初始资金')
        return
      }
      if (this.parameters.transactionCost === '0') {
        this.$message.error('请输入交易成本')
        return
      }
      let NewrecommendResult = null
      let allocations = []
      let riskResult = null
      try {
        NewrecommendResult = JSON.parse(localStorage.getItem('NewrecommendResult'))
        if (NewrecommendResult && NewrecommendResult.products && NewrecommendResult.products.length) {
          allocations = NewrecommendResult.products.map(item => ({
            assetCode: item.code,
            weight: item.weight
          }))
        }
        riskResult = JSON.parse(localStorage.getItem('riskResult'))
      } catch (e) {
        // console.error('[历史回测] 读取localStorage数据失败', e)
      }
      // console.log('[历史回测] NewrecommendResult', NewrecommendResult)

      if (!allocations.length) {
        this.loading = false
        this.$message.warning('未获取到资产配置数据，请重新调整权重')
        return
      }
      if (!riskResult || !riskResult.customerProfile) {
        this.loading = false
        this.$message.warning('未获取到客户风险画像，请重新完成风险评估')
        return
      }

      let params = {
        "caseId": null,
        "startDate": this.parameters.timeRange[0],
        "endDate": this.parameters.timeRange[1],
        "initialCapital": Number(this.parameters.initialFund),
        "allocations": allocations,
        "rebalanceFrequency": Number(this.parameters.rebalanceFreq),
        "transactionCostRate": Number(this.parameters.transactionCost),
        "benchmarkCode": this.parameters.benchmark,
        "customerProfile": riskResult.customerProfile
      }
      this.loading = true

      // console.log("params", params)
      apiOpen.Backtest(params).then(res => {
        this.loading = false
        localStorage.setItem('backtestParams', JSON.stringify(params))
        // 历史回测参数结果
        localStorage.setItem('backtestResult', JSON.stringify(res))
        // 初始虚拟本金
        localStorage.setItem('initialCapital', Number(this.parameters.initialFund))
        this.$router.push({ name: 'LishihuiceJieguo' })
      }).catch(err => {
        this.loading = false
        console.log(err)
        // this.$message.error(err)
        // this.$message.error('回测失败，请检查参数')
      })
      // this.$router.push({ name: 'LishihuiceJieguo' })
    },
    handleReset () {
      // 重新调权配置的逻辑
      // console.log('重新调权配置')
      this.$router.push({ name: 'Tiaozhengzichanbili' })
    },
  }
}
</script>

<style scoped lang="less">
/deep/.el-input-group__prepend {
  padding: 0 10px !important;
}

.lishihuiche-page {
  min-height: 100vh;
  // background: linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 50%, #f5f0ff 100%);
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 20px 40px;
}

.header {
  margin-bottom: 15px;
  text-align: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.logo i {
  font-size: 24px;
  color: #3b82f6;
}

.logo h1 {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.icon {
  width: 36px;
  height: 36px;
  background: #486dff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
}

.subtitle {
  font-size: 14px;
  color: #64748b;
  text-align: left;
  // margin-left: 40px;
}

.content {
  display: flex;
  gap: 32px;
  margin-bottom: 15px;
}

.left-panel {
  flex: 2;
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.left-panel:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 12px 0;
}

.parameter-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.parameter-item {
  display: flex;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  background: white;
  transition: all 0.3s ease;
}

.parameter-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.parameter-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.parameter-header i {
  font-size: 18px;
  color: #3b82f6;
}

.parameter-item:nth-child(2) .parameter-header i {
  color: #10b981;
}

.parameter-item:nth-child(3) .parameter-header i {
  color: #8b5cf6;
}

.parameter-item:nth-child(4) .parameter-header i {
  color: #f97316;
}

.parameter-item:nth-child(5) .parameter-header i {
  color: #3b82f6;
}

.parameter-description {
  font-size: 14px;
  color: #64748b;
}

.parameter-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.select-control {
  flex: 1;
  width: 120px;
}

/* 数字键盘 - 居中弹窗 */
.numpad-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.2s;
  min-width: 120px;
}

.numpad-trigger:hover {
  border-color: #3b82f6;
}

.numpad-display {
  font-size: 15px;
  font-weight: 500;
  color: #1e293b;
  font-feature-settings: 'tnum';
}

.numpad-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.numpad-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
  z-index: 2001;
}

.numpad-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.numpad-popup-close {
  width: 28px;
  height: 28px;
  border: none;
  background: #f1f5f9;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.numpad-popup-close:hover {
  background: #e2e8f0;
}

.numpad-popup-display {
  text-align: right;
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 10px;
  margin-bottom: 16px;
  font-feature-settings: 'tnum';
}

/* 日期选择弹窗 */
.datepicker-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  transition: all 0.2s;
  min-width: 240px;
}

@media screen and (max-width: 768px) {
  .datepicker-trigger {
    min-width: 0;
    width: 100%;
  }

  .datepicker-trigger-text {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.datepicker-trigger:hover {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.08);
}

.datepicker-trigger-icon {
  font-size: 16px;
  color: #6366f1;
  flex-shrink: 0;
}

.datepicker-trigger-text {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  font-feature-settings: 'tnum';
  letter-spacing: 0.3px;
}

.datepicker-trigger-text.placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.datepicker-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  max-width: calc(100vw - 32px);
  max-height: 85vh;
  // overflow-y: auto;
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  z-index: 2001;
  animation: datepickerIn 0.25s ease;
}

/* 中等屏（1024px 以下）缩小内边距 */
@media screen and (max-width: 1024px) {
  .datepicker-popup {
    padding: 18px;
    width: 480px;
  }

  .datepicker-col {
    padding: 12px 10px;
  }

  .datepicker-header {
    padding-bottom: 12px;
    margin-bottom: 14px;
  }

  .datepicker-body {
    margin-bottom: 14px;
  }

  .datepicker-select {
    padding: 8px 2px;
    font-size: 13px;
  }

  .datepicker-selects {
    gap: 4px;
  }
}

/* 小屏（768px 以下）紧凑布局 */
@media screen and (max-width: 768px) {
  .datepicker-popup {
    width: auto;
    padding: 16px;
    border-radius: 16px;
    max-height: 80vh;
  }

  .datepicker-body {
    flex-direction: column;
    gap: 10px;
  }

  .datepicker-col {
    padding: 12px;
  }

  .datepicker-divider {
    flex-direction: row;
    padding: 0;
    height: auto;
  }

  .datepicker-divider-line {
    width: auto;
    height: 2px;
    flex: 1;
    min-height: 0;
    background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
  }

  .datepicker-divider-icon {
    margin: 0 6px;
  }

  .datepicker-header {
    padding-bottom: 10px;
    margin-bottom: 12px;
  }

  .datepicker-header-title {
    font-size: 15px;
  }

  .datepicker-body {
    margin-bottom: 12px;
  }

  .datepicker-footer {
    gap: 8px;
  }

  .datepicker-btn {
    padding: 10px;
    font-size: 14px;
  }

  .datepicker-col-sub {
    margin-bottom: 6px;
  }

  .datepicker-col-header {
    margin-bottom: 8px;
  }
}

/* 极小屏（480px 以下）进一步压缩 */
@media screen and (max-width: 480px) {
  .datepicker-popup {
    padding: 12px;
    border-radius: 12px;
    max-height: 75vh;
  }

  .datepicker-col {
    padding: 8px 6px;
  }

  .datepicker-select {
    padding: 8px 0;
    font-size: 13px;
    min-height: 36px;
  }

  .datepicker-selects {
    gap: 3px;
  }

  .datepicker-header-title {
    font-size: 14px;
  }

  .datepicker-header-title svg {
    width: 16px;
    height: 16px;
  }
}

@keyframes datepickerIn {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.datepicker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 20px;
}

.datepicker-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
}

.datepicker-header-title svg {
  color: #6366f1;
}

.datepicker-body {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-bottom: 20px;
}

.datepicker-col {
  flex: 1;
  padding: 16px;
  border-radius: 12px;
  transition: background 0.2s;
}

.datepicker-col:first-child {
  background: linear-gradient(135deg, #eff6ff 0%, #f0f4ff 100%);
}

.datepicker-col:last-child {
  background: linear-gradient(135deg, #f0fdf4 0%, #f0faf0 100%);
}

.datepicker-col-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
}

.datepicker-col-header .col-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.datepicker-col-header .col-dot.start {
  background: #3b82f6;
}

.datepicker-col-header .col-dot.end {
  background: #10b981;
}

.datepicker-col-label {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 0.5px;
}

.datepicker-col-sub {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
  margin-bottom: 10px;
}

.datepicker-selects {
  display: flex;
  gap: 6px;
}

.datepicker-select {
  flex: 1;
  padding: 10px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
  outline: none;
  cursor: pointer;
  transition: all 0.15s;
  appearance: auto;
}

.datepicker-select:hover {
  border-color: #a5b4fc;
}

.datepicker-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.datepicker-divider {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  flex-shrink: 0;
}

.datepicker-divider-line {
  width: 2px;
  flex: 1;
  background: linear-gradient(180deg, #3b82f6 0%, #10b981 100%);
  border-radius: 1px;
  min-height: 32px;
}

.datepicker-divider-icon {
  font-size: 18px;
  color: #6366f1;
  margin: 6px 0;
  font-weight: 700;
}

/* 自定义日期选择器（替代原生 select 避免溢出裁剪） */
.datepicker-custom-select {
  flex: 1;
  position: relative;
}

.datepicker-custom-trigger {
  padding: 10px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  user-select: none;
}

.datepicker-custom-trigger:hover {
  border-color: #a5b4fc;
}

.datepicker-custom-select.open .datepicker-custom-trigger {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.datepicker-custom-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 180px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 10;
}

.datepicker-custom-option {
  padding: 8px 4px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  text-align: center;
  cursor: pointer;
  transition: background 0.12s;
}

.datepicker-custom-option:hover {
  background: #f1f5f9;
}

.datepicker-custom-option.selected {
  background: #e0e7ff;
  color: #6366f1;
  font-weight: 700;
}

.datepicker-footer {
  display: flex;
  gap: 10px;
}

.datepicker-btn {
  flex: 1;
  padding: 12px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  text-align: center;
}

.datepicker-btn-primary {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #fff;
}

.datepicker-btn-primary:hover {
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
  transform: translateY(-1px);
}

.datepicker-btn-secondary {
  background: #f1f5f9;
  color: #64748b;
}

.datepicker-btn-secondary:hover {
  background: #e2e8f0;
}

.numpad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 10px;
}

.numpad-btn {
  padding: 12px 0;
  font-size: 18px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.15s;
  text-align: center;
}

.numpad-btn:hover {
  background: #e2e8f0;
}

.numpad-btn:active {
  background: #cbd5e1;
}

.numpad-btn-zero {
  grid-column: 1 / 2;
}

.numpad-btn-del {
  color: #ef4444;
}

.numpad-confirm {
  width: 100%;
  padding: 10px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s;
}

.numpad-confirm:hover {
  opacity: 0.9;
}

.input-control {
  flex: 1;
  // border: 1px solid #e2e8f0;
  border-radius: 8px;
  // padding: 8px 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  width: 120px
}

.input-control:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.date-control {
  width: 360px;
}

.green-input {
  background: #ecfdf5;
  border-color: #d1fae5;
  color: #059669;
  font-weight: 600;
}

.green-input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.orange-input {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #d97706;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* .orange-input::after {
  content: '→ 0.12%';
  font-size: 12px;
  color: #d97706;
  font-weight: normal;
} */

.orange-input:focus {
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.preview-section {
  // width: 400px;
  background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
  color: white;
}

.preview-section .panel-title {
  color: white;
}

.preview-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: #4c83ff;
  margin: 8px 0;
  border-radius: 8px;
}

.preview-item:last-child {
  border-bottom: none;
}

.preview-label {
  font-size: 14px;
  opacity: 0.9;
}

.preview-value {
  font-size: 14px;
  font-weight: 600;
}

.warning-section {
  background: #eef3ff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.warning-section:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.warning-list {
  margin: 16px 0 0 0;
  padding-left: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #1e293b;
}

.warning-list li {
  margin-bottom: 8px;
}

.warning-list li:last-child {
  margin-bottom: 0;
}

.footer {
  display: flex;
  justify-content: center;
}

.start-btn {
  width: 300px;
  font-size: 18px;
}

.start-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}

.reset-btn {
  width: 300px;
  font-size: 18px;
  background: #e2e8f0;
  color: #64748b;
  margin-right: 10px;
}

.reset-btn:hover {
  background: #cbd5e1;
}

/* 横屏适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .lishihuiche-page {
    padding: 20px 40px;
  }

  .logo h1 {
    font-size: 32px;
  }

  .logo i {
    font-size: 32px;
  }

  .subtitle {
    font-size: 16px;
  }

  .content {
    gap: 20px;
  }

  .left-panel {
    /* padding: 40px; */
  }

  .parameter-list {
    gap: 8px;
  }

  .panel-title {
    font-size: 20px;
  }

  .parameter-item {
    padding: 16px;
  }

  .parameter-header {
    font-size: 18px;
  }

  .parameter-header i {
    font-size: 20px;
  }

  .parameter-description {
    font-size: 15px;
  }

  .preview-section {
    padding: 16px;
  }

  .preview-item {
    padding: 8px;
    background: #4c83ff;
    margin: 5px 0;
    border-radius: 8px;
  }

  .preview-label,
  .preview-value {
    font-size: 16px;
  }

  .warning-section {
    padding: 16px;
  }

  .warning-list {
    font-size: 15px;
  }

  .start-btn {
    padding: 14px 40px;
    font-size: 18px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .lishihuiche-page {
    padding: 20px 16px;
    min-height: 100vh;
    // background: linear-gradient(180deg, #f0f4ff 0%, #faf5ff 50%, #f0f9ff 100%);
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
  }

  .header {
    text-align: center;
    // padding-top: 10px;
    margin: 0;
  }

  .logo {
    // flex-direction: column;
    gap: 8px;
    justify-content: center;
    margin-bottom: 0;
  }

  .logo h1 {
    font-size: 18px;
    font-weight: 700;
    // color: #1e293b;
    letter-spacing: 0.5px;
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // background-clip: text;
    margin: 0;
  }

  .logo i {
    font-size: 20px;
    // color: #6366f1;
  }

  .subtitle {
    font-size: 13px;
    color: #64748b;
    margin-top: 8px;
  }

  .content {
    flex-direction: column;
    gap: 16px;
    /* flex: 1; */
    display: flex;
  }

  .right-panel {
    order: -1;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .left-panel {
    padding: 20px;
    border-radius: 16px;
    // box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    // background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    // border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .panel-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 16px;
  }

  .parameter-item {
    padding: 14px;
    margin-bottom: 12px;
    // background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    // border-radius: 10px;
    // border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .parameter-header {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 10px;
  }

  .parameter-header i {
    font-size: 14px;
    margin-right: 8px;
  }

  .parameter-description {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 10px;
  }

  .preview-section {
    padding: 20px;
    border-radius: 16px;
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    // box-shadow: 0 8px 24px rgba(99, 102, 241, 0.35);
  }

  .preview-section .panel-title {
    color: white;
    font-size: 16px;
    margin-bottom: 16px;
  }

  .preview-item {
    padding: 12px;
    background: rgba(255, 255, 255, 0.15);
    margin: 8px 0;
    border-radius: 10px;
    backdrop-filter: blur(10px);
  }

  .preview-label {
    font-size: 13px;
    opacity: 0.9;
  }

  .preview-value {
    font-size: 14px;
    font-weight: 600;
  }

  .warning-section {
    padding: 16px;
    border-radius: 12px;
    // background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    // border: 1px solid rgba(99, 102, 241, 0.1);
    // box-shadow: 0 4px 12px rgba(99, 102, 241, 0.08);
  }

  .warning-section .panel-title {
    font-size: 14px;
    // color: #4338ca;
    margin-bottom: 12px;
  }

  .warning-list {
    font-size: 12px;
    // color: #3730a3;
    padding-left: 16px;
  }

  .warning-list li {
    margin-bottom: 6px;
  }

  .footer {
    display: none;
    margin-top: 0;
    padding-top: 0;
  }

  .start-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .start-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  .start-btn:hover::before {
    left: 100%;
  }

  .start-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .lishihuiche-page {
    padding: 20px 16px;
  }

  .logo h1 {
    font-size: 18px;
  }

  .logo i {
    font-size: 18px;
  }

  .subtitle {
    font-size: 12px;
  }

  .left-panel {
    padding: 20px;
    border-radius: 12px;
  }

  .panel-title {
    font-size: 14px;
  }

  .parameter-item {
    padding: 16px;
    border-radius: 10px;
  }

  .parameter-header {
    font-size: 14px;
  }

  .parameter-header i {
    font-size: 16px;
  }

  .parameter-description {
    font-size: 12px;
  }

  .preview-section {
    padding: 16px;
    border-radius: 12px;
  }

  .preview-item {
    padding: 10px;
  }

  .preview-label,
  .preview-value {
    font-size: 12px;
  }

  .warning-section {
    padding: 16px;
    border-radius: 12px;
  }

  .warning-list {
    font-size: 12px;
  }

  .start-btn {
    padding: 8px 20px;
    font-size: 13px;
  }
}
</style>